const AOS = require('aos');
const $ = require('jquery');
// const _ = require('lodash');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');
require('hamburgers');
// require('magnific-popup'); 
// Uncomment as necessary

window.jQuery = $;

window.onscroll = function () {
  let image = $(".scroll-banner .img-block")[0];
  const section = $(".scroll-banner");
  let value = window.pageYOffset / section.offset().top + 1;
  let scale = `scale(${value})`;
  console.log(scale);
  $(image).css("transform", scale);
};

$(document).ready(function () {
  // Scroll check.
  function scrollCheck() {
    var scroll = $(window).scrollTop();
    if (scroll > 0) {
      $("#header").addClass("scroll");
    } else {
      $("#header").removeClass("scroll");
    }
  }
  scrollCheck();
  $(window).on("scroll", function () {
    scrollCheck();
  });

  $(window).on("mousewheel DOMMouseScroll", function (event) {
    var $window = $(window);
    event.preventDefault();

    const scroll_time = 1.2;
    const scroll_distance = 170;

    const delta =
      event.originalEvent.wheelDelta / 120 || -event.originalEvent.detail / 3;
    const scrollTop = $window.scrollTop();
    const finalScroll = scrollTop - parseInt(delta * scroll_distance);

    TweenMax.to($window, scroll_time, {
      scrollTo: {
        y: finalScroll,
        autoKill: true,
      },
      ease: Power1.easeOut,
      autoKill: true,
      overwrite: 5,
    });
  });

  // Smooth scroll.
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .not(".tab")
    .on("click", function (event) {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          event.preventDefault();
          var header = $("#header").outerHeight();
          $("html, body").animate(
            {
              scrollTop: target.offset().top - header,
            },
            1000
          );
        }
      }
    });

  $(".hamburger").click(function () {
    $(this).toggleClass("is-active");
    $("#mobile-navi").toggleClass("is-active");
    $("#header").toggleClass("is-active");
  });

  // $(".toggle").click(function(){
  //   $( '.dropdown-navi, .service-link, .popup-overlay' ).removeClass("is-active");
  // });

  // $( ".service-link" ).mouseenter(function() {
  //   $( '.dropdown-navi, .service-link, .popup-overlay' ).addClass( "is-active" );
  // });

  $(".relationship-carousel").slick({
    dots: false,
    arrows: false,
    infinite: true,
    arrows: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 2,
    mobileFirst: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".bio-carousel").slick({
    autoplay: false,
    dots: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fas fa-long-arrow-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fas fa-long-arrow-left"></i></button>',
  });

  // Scroll trigger.
  $("#scroll-trigger").on("click", function () {
    var position = $("#first");

    var header = $("#header").outerHeight();

    $("html, body").animate(
      {
        scrollTop: position.offset().top - header,
      },
      1500
    );
  });

  // AOS.
  AOS.init();
  setTimeout(function () {
    AOS.init();
  }, 500);
});

// Google Maps.
(function ($) {
  function new_map($el) {
    var $markers = $el.find(".marker");
    var args = {
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: "administrative.land_parcel",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [{ visibility: "off" }],
        },
        { featureType: "poi.business", stylers: [{ visibility: "off" }] },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "road.local",
          elementType: "labels",
          stylers: [{ visibility: "off" }],
        },
        { featureType: "transit", stylers: [{ visibility: "off" }] },
      ],
      zoom: 16,
    };
    var map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function () {
      add_marker($(this), map);
    });
    center_map(map);
    return map;
  }

  function add_marker($marker, map) {
    var latlng = new google.maps.LatLng(
      $marker.attr("data-lat"),
      $marker.attr("data-lng")
    );
    var icon = {
      url: "" + $marker.attr("data-icon") + "",
      scaledSize: new google.maps.Size(48, 48),
    };
    var marker = new google.maps.Marker({
      icon: icon,
      map: map,
      position: latlng,
    });
    map.markers.push(marker);
    if ($marker.html()) {
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );
      bounds.extend(latlng);
    });
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(16);
    } else {
      map.fitBounds(bounds);
    }
  }

  var map = null;
  $(document).ready(function () {
    $(".map").each(function () {
      map = new_map($(this));
    });
  });
})($);
